/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

export const OverflowText = styled.span`
  color: #00a74f;
  cursor: pointer;
  fontsize: ${({
  font
}) => font.small};
`;